<template>
  <div class="shoplist">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="searchdiv">
        <div class="sitem">
          <menu class="active" @click="queryGoodsPage(1)"><p>全部</p></menu>
          <menu class="no" @click="queryGoodsPage(1, 'saleStartDate', 1)"><p>上架时间</p></menu>
          <menu class="no" @click="queryGoodsPage(1, 'price', 1)"><p>商品价格</p></menu>
        </div>
      </div>
      <div>
        <div class="contentdiv">
          <ul class="itemdiv">
            <template v-for="(item, index) in list">
              <li class="item" :key="index">
                <a href="javascript:void(0)" @click="goDetail(item.id)" style="color:#323232;">
                  <dl>
                    <dt>
                      <img :src="item.firstPhoto" />
                    </dt>
                    <dd>
                      <p>{{ item.proName }}</p>
                      <p class="price">
                        ¥{{ item.price }}
                        <i
                          v-if="$store.getters.mycollect.indexOf(item.id) > -1"
                          class="iconfont"
                          style="color:#dea767;padding:0.3rem;display:block;"
                          @click.stop="cancelCollect(item.id)"
                          >&#xe627;</i
                        >
                        <i
                          v-else
                          class="iconfont"
                          style="padding:0.3rem;display:block;"
                          @click.stop="addCollect(item.id)"
                          >&#xe627;</i
                        >
                      </p>
                    </dd>
                  </dl>
                </a>
              </li>
            </template>
            <!-- <li class="item">
              <a href="/shop/detail/0/1/" style="color:#323232;">
                <dl>
                  <dt>
                    <img src="../../assets/shop.jpg" />
                  </dt>
                  <dd>
                    <p>祭思套餐</p>
                    <p class="price">
                      ¥159
                      <i class="iconfont">&#xe627;</i>
                    </p>
                  </dd>
                </dl>
              </a>
            </li> -->
          </ul>
          <div class="clear-both" style="height: 0rem;"></div>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  name: 'shopList',
  data() {
    return {
      count: 0,
      isLoading: false,
      category: '',
      list: [],
      total: 0,
      page: 1,
      sort: {},
    }
  },
  created() {
    var params = this.$route.query
    this.category = params['category']
    this.page = 1
    this.queryGoodsPage(this.page)
  },
  methods: {
    addCollect(id) {
      var that = this
      this.$submit(
        '/api/mycollect/addCollect',
        {
          myId: this.$store.getters.userId,
          goodsId: id,
        },
        function(res) {
          if (res['code'] === 1) {
            //that.$store.dispatch('mystatus', 0)
            // alert('OK')
            if (that.$store.getters.mycollect.indexOf(id) < 0) {
              that.$store.getters.mycollect.push(id)
            }
          }
        }
      )
    },
    cancelCollect(id) {
      var that = this
      this.$submit(
        '/api/mycollect/removeCollect',
        {
          myId: this.$store.getters.userId,
          goodsId: id,
        },
        function(res) {
          if (res['code'] === 1) {
            //that.$store.dispatch('mystatus', 0)
            // alert('OK')
            if (that.$store.getters.mycollect.indexOf(id) > -1) {
              let _index = that.$store.getters.mycollect.indexOf(id)
              that.$store.getters.mycollect.splice(_index, 1)
            }
          }
        }
      )
    },

    goDetail(id) {
      this.$router.push({ path: '/shop/detail/' + id, query: {} })
    },
    queryGoodsPage(page, orderName, orderNum) {
      var that = this
      var param = {channel: 'shop', category: this.category, page: this.page }
      if (page) {
        this.page = page
      } else {
        this.page = 1
      }
      if (orderName && orderNum) {
        this.sort = { orderName: orderNum }
      } else {
        this.sort = {}
      }
      param['page'] = this.page
      param['sort'] = this.sort
      this.$queryPage(
        'ProGoods',
        param,
        [
          'id',
          'firstPhoto',
          'proName',
          'specification',
          'gallery',
          'price',
          // 'proDetail',
          // 'proNotice',
          // 'proFeature',
        ],
        function(res) {
          that.$fill(that.list, res['data'])
          that.goodsTotal = res['total']
        }
      )
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false
        this.count++
      }, 1000)
    },
  },
}
</script>

<style>
.shoplist .searchdiv {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}

.shoplist .searchdiv {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.shoplist .searchdiv .sitem {
  width: 100%;
  height: 4.6rem;
  box-sizing: border-box;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}
.shoplist .sitem .active {
  width: 33.3%;
  box-sizing: border-box;
  float: left;
  line-height: 2.3rem;
  font-size: 1.4rem;
}
.shoplist .sitem .active p {
  width: 100%;
  color: #15a892 !important;
}
.shoplist .sitem .no {
  width: 33.3%;
  box-sizing: border-box;
  float: left;
  line-height: 2.3rem;
  font-size: 1.4rem;
}
.shoplist .sitem .no p {
  width: 100%;
  color: #000;
}

.shoplist .contentdiv {
  padding: 0 1.2rem;
  background-color: #f3f3f3;
}
.shoplist .itemdiv {
  margin-top: 0.85rem;
}

.shoplist .contentdiv .itemdiv .item:nth-of-type(odd) {
  margin-right: 1rem;
}

.shoplist .contentdiv .itemdiv .item {
  float: left;
  width: calc(50% - 0.6rem);
  margin-bottom: 1rem;
  box-sizing: border-box;
  background-color: #fff;
}
.shoplist .contentdiv .itemdiv .item dl {
  width: 100%;
}
.shoplist .contentdiv .itemdiv .item dl dt img {
  width: 100%;
  max-height: 11.3rem;
  display: block;
}
.shoplist .contentdiv .itemdiv .item dl dd {
  padding: 0.6em 1.4rem;
  font-size: 1.4rem;
  line-height: 2rem;
}

.shoplist .clear-both {
  clear: both;
  height: 5rem;
  height: 0rem;
}
.shoplist .price {
  padding-top: 0.3rem;
  color: #15a892;
}
.shoplist .price i {
  float: right;
  position: relative;
  top: 0.2rem;
  display: block;
  color: #777;
}
</style>
